// extracted by mini-css-extract-plugin
export var card = "_as-1";
export var container = "_as-0";